import * as yup from "yup";
import { Validation } from "../../../utils/validations";

export const validationSchema = yup.object({
  name: yup
    .string()
    .required("Nome completo é obrigatório")
    .test("is-full-name", "Nome completo inválido", (value) => {
      const names = value?.trim().split(" ");
      return names?.length > 1;
    }),
  phone: yup
    .string()
    .test("len", "Número de telefone inválido", (value) => {
      const val_length_without_dashes = value?.replace(/\D/g, "").length;
      return val_length_without_dashes === 11;
    })
    .required("Telefone é obrigatório"),
  birthdate: yup
    .string()
    .test("is-valid-date", "Data de nascimento inválida", (value) => {
      return value ? Validation.isValidDate(value) : false;
    })
    .test("is-over-18", "Você deve ter no mínimo 18 anos", (value) => {
      if (value) {
        const year = value.split("/").map(Number)[2];
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const minAgeYear = currentYear - 18;

        return year <= minAgeYear;
      }

      return false;
    })
    .required("Data de nascimento é obrigatório"),
  email: yup
    .string()
    .email("E-mail inválido")
    .required("E-mail é obrigatório"),
  street: yup
    .string()
    .required("Rua é obrigatório"),
  number: yup
    .string()
    .required("Número é obrigatório"),
  neighborhood: yup
    .string()
    .required("Bairro é obrigatório"),
  city: yup
    .string()
    .required("Cidade é obrigatório"),
  state: yup
    .string()
    .required("Estado é obrigatório"),
  cep: yup
    .string()
    .required("CEP é obrigatório")
    .matches(/^[0-9]{5}-?[0-9]{3}$/, "Formato de CEP inválido")
    .test("len", "CEP deve ter 8 dígitos", (value) => {
      const cleanedValue = value?.replace(/\D/g, "");
      return cleanedValue?.length === 8;
    }),
});

export const validationSchemaPassword = yup.object({
  passwordDefault: yup.string().required("Senha é obrigatório").min(8, "Senha muito curta"),
  password: yup.string().required("Senha é obrigatório").min(8, "Senha muito curta"),
  confirmPassword: yup
    .string()
    .required("Confirmação de senha é obrigatório")
    .oneOf([yup.ref("password")], "As senhas não coincidem"),
});